import gallery01 from '@assets/images/gallery/gallery01.webp';
import gallery02 from '@assets/images/gallery/gallery02.webp';
import gallery03 from '@assets/images/gallery/gallery03.webp';
import gallery04 from '@assets/images/gallery/gallery04.webp';
import gallery05 from '@assets/images/gallery/gallery05.webp';
import gallery06 from '@assets/images/gallery/gallery06.webp';
import gallery07 from '@assets/images/gallery/gallery07.webp';
import gallery08 from '@assets/images/gallery/gallery08.webp';
import gallery09 from '@assets/images/gallery/gallery09.webp';
import gallery10 from '@assets/images/gallery/gallery10.webp';
import gallery11 from '@assets/images/gallery/gallery11.webp';
import gallery12 from '@assets/images/gallery/gallery12.webp';
import gallery13 from '@assets/images/gallery/gallery13.webp';
import gallery14 from '@assets/images/gallery/gallery14.webp';
import gallery15 from '@assets/images/gallery/gallery15.webp';



export const galleryItems = [
	{ image: gallery01, key: 'item01' },
	{ image: gallery02, key: 'item02' },
	{ image: gallery03, key: 'item03' },
	{ image: gallery04, key: 'item04' },
	{ image: gallery05, key: 'item05' },
	{ image: gallery06, key: 'item06' },
	{ image: gallery07, key: 'item07' },
	{ image: gallery08, key: 'item08' },
	{ image: gallery09, key: 'item09' },
	{ image: gallery10, key: 'item10' },
	{ image: gallery11, key: 'item11' },
	{ image: gallery12, key: 'item12' },
	{ image: gallery13, key: 'item13' },
	{ image: gallery14, key: 'item14' },
	{ image: gallery15, key: 'item15' },
] as const;